import { isUndefined } from 'lodash';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './style.less';

type Props = {
    icon: string;
    title: string;
    showAdd?: boolean;
    visible?: boolean;
    onAdd?: () => void;
    onToggleVisible?: () => void;
    onRemove?: () => void;
};

export const EffectPropsContainer: React.FC<Props> = ({
    children,
    icon,
    title,
    showAdd,
    visible,
    onAdd,
    onToggleVisible,
    onRemove,
}) => {
    const showIcons = !showAdd && !isUndefined(visible) && !isUndefined(onToggleVisible) && !isUndefined(onRemove);

    const handleAdd = () => {
        if (!showAdd) return;
        if (onAdd) onAdd();
    };

    return (
        <div className="effect-props-container">
            <div className="effect-props-container__header">
                <div className="effect-props-container__info">
                    <IconFont name={icon} fontSize={14} />
                    <span className="effect-props-container__title">{title}</span>
                </div>
                {showAdd ? (
                    <div className="effect-props-container__icon" onClick={handleAdd}>
                        <IconFont name="PlusCircleBold" fontSize={14} />
                    </div>
                ) : null}
                {showIcons ? (
                    <div className="effect-props-container__icons">
                        <div className="effect-props-container__icon" onClick={onToggleVisible}>
                            <IconFont name={visible ? 'VisibleBold' : 'InvisibleBold'} fontSize={14} />
                        </div>
                        <div className="effect-props-container__icon" onClick={onRemove}>
                            <IconFont name="TrashCanBold" fontSize={14} />
                        </div>
                    </div>
                ) : null}
            </div>
            <div className="effect-props-container__content">{children}</div>
        </div>
    );
};
